<template>

    <div>
        <a-modal
            :title="modalState.title"
            :visible="modalState.visible"
            :confirm-loading="confirmLoading"
            width="650px"
            @cancel="handleCancel"
        >
            <a-form-model
                :model="modalState.menuData"
                ref="ruleForm"
                :rules="rules"
                :layout="formItemLayout"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
            >
                <a-form-model-item ref="name" label="权限/菜单名" prop="name">
                    <a-input
                        v-model="modalState.menuData.name"
                        aria-placeholder="请输入权限/菜单名"
                        @blur="
                        () => {
                            $refs.name.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>
                <a-form-model-item ref="name" label="子名称" prop="subname">
                    <a-input
                        v-model="modalState.menuData.subname"
                        aria-placeholder="请输入子名称"
                        @blur="
                        () => {
                            $refs.name.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>


                <a-form-model-item label="菜单类型">
                    <a-select v-model="modalState.menuData.type" placeholder="请选择菜单" prop="type" @change="typeOnChange"
                              style="width: 85%">
                        <a-select-option value="0">菜单</a-select-option>
                        <a-select-option value="1">权限</a-select-option>
                        <a-select-option value="2">复杂菜单</a-select-option>
                        <a-select-option value="3">复杂权限</a-select-option>
                    </a-select>
                    <a-popover title="菜单类型" style="width: 8%">
                        <template slot="content">
                            <p>选项类型分普通类型（菜单、权限）与复杂类型（复杂菜单、复杂权限）</p>
                            <p>普通类型为字符串类型，复杂类型为Map类型,key为appcode,value为url</p>
                            <p>例如：普通类型（/user/list）,复杂类型：(cloudpos_h5:/syjuser/list ,lingshou_pc:)</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;"/>
                    </a-popover>
                </a-form-model-item>

                <a-form-model-item ref="url" label="路径URL" prop="url">
                    <a-input
                        v-if="modalState.menuData.type==0||modalState.menuData.type==1"
                        v-model="modalState.menuData.url"
                        aria-placeholder="请输入URL"
                        @blur="() => {$refs.url.onFieldBlur();} "
                    />
                    <a-button v-if="modalState.menuData.type==2||modalState.menuData.type==3" type="dashed"
                              style="width: 60%"
                              @click="addMenu">
                        <a-icon type="plus"/>
                        添加配置
                    </a-button>

                    <span v-if="modalState.menuData.type==2||modalState.menuData.type==3">
                    <MenuModal :menuModalStatus="menuModalStatus" @onModalHide="onNewConfig"></MenuModal>
                    <a-form-model-item v-for="(k, index) in modalState.urlMap" :key="index">
                        <!--                    {{ k.name }}{{ k.value }}-->
                        <label style="width:50px">{{ k.name }}:</label>
                        <a-input v-model="k.value" style="width: 260px"/>
                        <a-icon style="width: 15px" class="dynamic-delete-button" type="minus-circle-o"
                                @click="() => remove(k)"/>
                    </a-form-model-item>
                    </span>
                </a-form-model-item>
                <a-form-model-item ref="menucode" label="菜单编码" prop="menucode">

                    <a-input-search
                        v-if="(!modalState.menuData.id) && (modalState.menuData.id <= 0 || isEditblleMenucode == '')"
                        v-model="modalState.menuData.menucode"
                        enter-button="生成编码"
                        @search="generateMenuCode"
                        @blur="
                    () => {
                        $refs.menucode.onFieldBlur();
                    }
                    "
                    />
                    <span class="form_span" v-else>{{ modalState.menuData.menucode }}</span>
                </a-form-model-item>

                <a-form-model-item ref="actionpath" label="后端action地址" prop="actionpath">
                    <a-input
                        v-if="modalState.menuData.type==0||modalState.menuData.type==1"
                        v-model="modalState.menuData.actionpath"
                        aria-placeholder="请输入action地址"
                        @blur="() => {$refs.actionpath.onFieldBlur();}"
                    />
                    <a-button v-if="modalState.menuData.type==2||modalState.menuData.type==3" type="dashed"
                              style="width: 60%"
                              @click="addAction">
                        <a-icon type="plus"/>
                        添加配置
                    </a-button>
                    <span v-if="modalState.menuData.type==2||modalState.menuData.type==3">
                    <MenuModal :menuModalStatus="actionModalStatus" @onModalHide="onNewActionConfig"></MenuModal>
                    <a-form-model-item v-for="(k, index) in modalState.actionpathMap" :key="index">
                        <!--                    {{ k.name }}{{ k.value }}-->
                        <label style="width:50px">{{ k.name }}:</label>
                        <a-input v-model="k.value" style="width: 260px"/>
                        <a-icon style="width: 15px" class="dynamic-delete-button" type="minus-circle-o"
                                @click="() => removeAction(k)"/>
                    </a-form-model-item>
                    </span>
                </a-form-model-item>
                <a-form-model-item label="状态">
                    <a-select v-model="modalState.menuData.status" placeholder="使用" prop="status">
                        <a-select-option value="0">禁用</a-select-option>
                        <a-select-option value="1">使用</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item ref="remark" label="备注" prop="remark">
                    <a-input
                        v-model="modalState.menuData.remark"
                        aria-placeholder="请输入备注，例如：版本号v1  分支号0915"
                        @blur="
                        () => {
                            $refs.remark.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>
                <a-form-model-item ref="ordernum" label="排序" prop="ordernum">
                    <a-input
                        v-model="modalState.menuData.ordernum"
                        aria-placeholder="请输入排序号"
                    />
                </a-form-model-item>
                <a-form-model-item ref="icon" label="图标名" prop="icon">
                    <a-icon :type="modalState.menuData.icon" style="width: 10%"/>
                    <a-input style="width: 90%"
                             v-model="modalState.menuData.icon"
                             aria-placeholder="请输入图标名"
                    />
                </a-form-model-item>
                <a-form-model-item ref="hookconfig" label="自定义扩展" prop="hookconfig">
                    <a-input style="width: 85%;"
                             v-model="modalState.menuData.hookconfig"
                             aria-placeholder="自定义扩展"
                    />
                    <a-popover title="自定义扩展" style="width: 8%;">
                        <template slot="content">
                            <p>此属性设置为接入的系统自定义扩展参数，对于有额外参数配置需要的场景可以通过此字段存储</p>
                            <p>例如，如果需要标注菜单的适用行业为商超便利,标注适用门店类型为单店版（1）</p>
                            <p>可以配置成：{industryType:1,shoptype:2 }</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;"/>
                    </a-popover>
                </a-form-model-item>
            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    保存
                </a-button>
            </template>


        </a-modal>
    </div>

</template>
<script>

import MenuModal from './menumodal'

export default {

    data() {
        return {
            menuModalStatus: {
                isShow: false,
            },
            actionModalStatus: {
                isShow: false,
            },
            labelCol: {span: 6},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请填写菜单名', trigger: 'blur'},
                ],
                url: [
                    {required: true, message: '请填写URL', trigger: 'blur'},
                ],
                remark: [
                    {required: true, message: '请填写备注', trigger: 'blur'},
                ],
                menucode:[
                    {required: true, message: '请填写Menucode', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            formItemLayout: 'inline',
            modalState: {
                visible: false,
                urlMap: [],
                actionpathMap: [],
                menuData: {}
            },
            isEditblleMenucode:false,
            // dynamicConfig: []
        };
    },
    computed: {},
    components: {
        MenuModal
    },
    props: {},
    methods: {
        formatZero(num, len) {
            if (String(num).length > len) return num;
            return (Array(len).join(0) + num).slice(-len);
        },
        generateNum(num) {
            let s = [];
            let hexDigits = '0123456789abcdef';
            for (let i = 0; i < num; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            return s.join('');
        },
        generateMenuCode() {
            this.confirmLoading = true
            let value = this.modalState.menuData.platfromcode
            if (this.modalState.menuData.id) {
                value += this.formatZero(this.modalState.menuData.id, 8);
                value += this.generateNum(2)
            } else {
                value += this.generateNum(10)
            }
            this.modalState.menuData.menucode = value.toUpperCase()
            this.confirmLoading = false
        },
        typeOnChange() {
            if (this.modalState.menuData.type == 2 || this.modalState.menuData.type == 3) {
                try {
                    this.modalState.urlMap = this.parseMapToArr(JSON.parse(this.modalState.menuData.url))
                } catch (e) {
                    console.log(this.modalState.menuData.url)
                }

            } else {
                console.log(this.modalState.menuData.type)
            }
        },
        addMenu() {
            this.menuModalStatus.isShow = true;
        },
        addAction() {
            this.actionModalStatus.isShow = true;
        },
        remove(k) {
            this.confirmLoading = true
            console.log(k);
            this.modalState.urlMap = this.modalState.urlMap.filter((p_item) => {
                return p_item.name != k.name
            })
            if (this.modalState.menuData.type == 2 || this.modalState.menuData.type == 3 == 3) {
                this.modalState.menuData.url = JSON.stringify(this.parseArrToMap(this.modalState.urlMap));
            }
            this.confirmLoading = false
        },
        removeAction(k) {
            this.confirmLoading = true
            console.log(k);
            this.modalState.menuData.actionpath = this.modalState.actionpath.filter((p_item) => {
                return p_item.name != k.name
            })
            if (this.modalState.menuData.type == 2 || this.modalState.menuData.type == 3) {
                this.modalState.menuData.actionpath = JSON.stringiafy(this.parseArrToMap(this.modalState.menuData.actionpath));
            }
            this.confirmLoading = false
        },
        onNewConfig(v) {
            this.confirmLoading = true
            if (v) {
                if (this.modalState.urlMap == undefined) {
                    this.modalState.urlMap = []
                }
                let filterList = this.modalState.urlMap.filter((p_item) => {
                    return p_item.name == v.name
                })
                if (filterList.length > 0) {
                    this.message.error("已存在相同的配置名");
                } else {
                    // this.modalState.urlMap[v.name] = v.value
                    this.modalState.urlMap.push({...v})
                }
            }
            if (this.modalState.menuData.type == 2 || this.modalState.menuData.type == 3) {
                this.modalState.menuData.url = JSON.stringify(this.parseArrToMap(this.modalState.urlMap));
            }
            this.menuModalStatus.isShow = false
            this.confirmLoading = false
        },
        onNewActionConfig(v) {
            this.confirmLoading = true
            if (v) {
                if (this.modalState.actionpathMap == undefined) {
                    this.modalState.actionpathMap = []
                }
                let filterList = this.modalState.actionpathMap.filter((p_item) => {
                    return p_item.name == v.name
                })
                if (filterList.length > 0) {
                    this.message.error("已存在相同的配置名");
                } else {
                    // this.modalState.urlMap[v.name] = v.value
                    this.modalState.actionpathMap.push({...v})
                }
            }
            if (this.modalState.type == 2 || this.modalState.type == 3) {
                this.modalState.actionpath = JSON.stringify(this.parseArrToMap(this.modalState.actionpathMap));
            }
            this.actionModalStatus.isShow = false
            this.confirmLoading = false
        },
        onModalInit(item) {
            let that = this;
            that.modalState = {
                visible: true,
                menuData: {
                    id: item.id,
                    pid: item.pid,
                    pmenucode:item.pmenucode,
                    name: item.name,
                    subname: item.subname,
                    type: item.type,
                    url: item.url,
                    menucode: item.menucode,
                    actionpath: item.actionpath,
                    status: item.status,
                    remark: item.remark,
                    ordernum: item.ordernum,
                    icon: item.icon,
                    hookconfig: item.hookconfig,
                    platfromcode: item.platfromcode,
                    level: item.level,
                    createtime: item.createtime,
                    updatetime: item.updatetime,
                }
            }
            if(!item.menucode){
                that.generateMenuCode();
            }
            that.isEditblleMenucode =  that.modalState.menuData.menucode == ""
            this.typeOnChange();
        },
        parseArrToMap(arr) {
            let map = {}
            for (let index in arr) {
                let item = arr[index]
                map[item.name] = item.value
            }
            return map
        },
        parseMapToArr(map) {
            let arr = []
            for (let key in map) {
                arr.push({"name": key, "value": map[key]})
                // let item = arr[index]
                // map[item.name] = item.value
            }
            return arr
        },

        handleOk() {
            let that = this
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(that.modalState.menuData);
                    that.confirmLoading = true;
                    if (this.modalState.menuData.type == 2 || this.modalState.menuData.type == 3) {
                        this.modalState.menuData.url = JSON.stringify(this.parseArrToMap(this.modalState.urlMap));
                        this.modalState.menuData.actionpath = JSON.stringify(this.parseArrToMap(this.modalState.actionpathMap));
                    }
                    // let arr = that.parseMapToArr(JSON.parse(that.modalState.url))
                    // console.log(arr)
                    if (that.modalState.menuData.id) {
                        //编辑
                        this.$store
                            .dispatch({
                                type: "ums/updateMenuConfig",
                                params: this.modalState.menuData
                            })
                            .then((response) => {
                                console.log(response)
                                that.modalState.visible = false;
                                that.$emit('onModalHide');
                                that.confirmLoading = false;
                            });
                    } else {
                        //新增
                        that.$store
                            .dispatch({
                                type: "ums/insertMenuConfig",
                                params: this.modalState.menuData
                            })
                            .then((response) => {
                                console.log(response)
                                if (response.data.success == '1') {
                                    that.modalState.visible = false;
                                    that.$emit('onModalHide');
                                }
                                that.confirmLoading = false;

                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel(e) {
            e.preventDefault()
            this.resetForm();
            this.modalState.visible = false;
            this.$emit('onModalHide');
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    width: 100%;
}
</style>
